let language = {
    BILLING_METHOD_FULL_NAME: "全名:",
    BILLING_METHOD_COMPANY: "公司:",
    BILLING_METHOD_COUNTRY_REGION: "国家/地区:",
    BILLING_METHOD_PHONE: "电话:",
    BILLING_METHOD_POSTAL_CODE: "邮政编码:",
    BILLING_METHOD_ADDRESS1: "地址1:",
    BILLING_METHOD_ADDRESS2: "地址2:",
    BILLING_METHOD_CITY_TOWN: "城市/城镇:",
    BILLING_METHOD_CAN_BE_EMPTY: "不能是空的。",
    BILLING_METHOD_NO_RESULTS_MATCH: "没有匹配结果",
    BILLING_METHOD_PHONE_FORMAT_INVALID: "电话格式无效。",
    BILLING_METHOD_SELECT_FRON_ADDRESS_BOOK: "从地址簿选择",

};

export { language }
